import * as lodash from 'lodash';

export type Language = 'ko' | 'en' | 'zh-Hant' | 'zh-Hans' | 'th' | 'ja';
export interface Messages {
  ko: { [key: string]: string | void };
  en: { [key: string]: string | void };
  'zh-Hant': { [key: string]: string | void };
  'zh-Hans': { [key: string]: string | void };
  th: { [key: string]: string | void };
};

export const languages: Language[] = ['ko', 'en', 'zh-Hant', 'zh-Hans', 'th', 'ja'];

export function getMessages(locale: Language): Messages | void {
  try {
    return require(`../messages/${locale}.yml`);
  } catch {
    return;
  }
}

export const messages = languages.reduce(
  (state, language: Language) => ({
    ...state,
    [language]: require(`../messages/${language}.yml`),
  }),
  {},
) as Messages;

export function getText(language: Language, key: string): string {
  const message = lodash.get(messages[language], key);
  if (!message) {
    return key;
  }
  return message;
}

export function formatText(text: string, ...replacements: string[]): string {
  return [text, ...replacements].reduce(
    (prevText, replacement, index) => prevText.replace(`%{${index.toString()}}`, replacement),
  );
}

export function getImgSrc(path: string): string {
  return require(`../images/${path}`);
}
